export default "/images/vendor/flag-icons/flags/4x3/cp.svg?f6b10f55c03f66f740187a9e581f7e27";